import { render } from "./UnitDisposition.vue?vue&type=template&id=13bbb606&scoped=true"
import script from "./UnitDisposition.vue?vue&type=script&lang=js"
export * from "./UnitDisposition.vue?vue&type=script&lang=js"

import "./UnitDisposition.vue?vue&type=style&index=0&id=13bbb606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bbb606"]])

export default __exports__